/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcAssetsV1AssetQueryServiceAssetGetAssetGetRequest, IxcAssetsV1AssetQueryServiceAssetGetResponse } from '@interxfi/types';

export const IXC_ASSETS_V1_ASSET_QUERY_SERVICE_ASSET_GET_AUDIENCE = ['clearing', 'program'];

export async function ixcAssetsV1AssetQueryServiceAssetGet(baseUrl: string | undefined, request?: IxcAssetsV1AssetQueryServiceAssetGetAssetGetRequest, requestInit?: RequestInit): Promise<IxcAssetsV1AssetQueryServiceAssetGetResponse | undefined> { return makeRequest<IxcAssetsV1AssetQueryServiceAssetGetResponse, IxcAssetsV1AssetQueryServiceAssetGetAssetGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/assets/v1/asset/q/:assetId', request, requestInit)); }

